module.exports = __webpack_public_path__ + "static/media/JustAct Icons for Case Manager Site_V4-03.8c9cee36.svg";